import { createApi } from '@reduxjs/toolkit/query/react';

import { makeBaseQueryWithReauth } from './endpoints/baseQueryWithReauth';
import { getOrganizationUrl } from './host-urls';

/**
 * RTK Query instance for the organization host (one instance per backend host,
 * ADR-0015). Endpoints are hand-written and injected via `injectEndpoints`.
 */
export const organizationApi = createApi({
  reducerPath: 'organizationApi',
  baseQuery: makeBaseQueryWithReauth(getOrganizationUrl),
  endpoints: () => ({})
});
